'use strict';

function _CryptoController() {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.el = {};
  this._classes = {};

  this.extends = [_AccountController];
  this.cryptoInitPromises = [];

  this._history = new History();
  this._session = new Session();

  this.init = function () {
    this.path = window.location.pathname;
    this._productSettings = new ProductSettings(this.presenter);
    // check for crypto eligibility, if ineligible and attempting to access
    // a crypto page with available actions, redirect to safe pages
    if (this.presenter.getModelProperty('account.eligibility.crypto') !== true) {
      this.whiteListedPages = [this.paths.account.dashboard, this.paths.crypto.watch, this.paths.account.referral_panel];
      if (this.whiteListedPages.indexOf(this.path) === -1) {
        return this._history.replaceUrl(this.paths.account.dashboard);
      }
    }

    this._super(); // _AccountController
  };

  this.initAllReady = function () {
    this._super(); // _AccountController

    // crypto state requires these 1-2 sets of data to be determined based on state
    if (this.presenter.getModelProperty('account.eligibility.crypto') == 1) {
      $.when.apply($, this.cryptoInitPromises).then(this._onCryptoModelsReady.bind(this));
    }
  };

  this.initPage = function () {};

  this._onCryptoModelsReady = function () {
    this.presenter.scanDOM();
    this.initPage(); // alternative to promise subscription.
  };
}